import React from 'react';
import { useTranslation } from 'react-i18next';
import MemberOnlyOverlay from '../components/MemberOnlyOverlay';
import SEO from '../components/SEO';

const Partners = () => {
  const { t } = useTranslation();

  const partners = [
    { name: 'International Society of Hypertension (ISH)', desc: 'Global partner supporting African hypertension research and guideline development.', type: 'International' },
    { name: 'World Hypertension League (WHL)', desc: 'Collaborating on World Hypertension Day campaigns and public awareness initiatives across Africa.', type: 'International' },
    { name: 'Pan-African Society of Cardiology (PASCAR)', desc: 'Sister organization advancing cardiovascular health across the African continent.', type: 'Continental' },
    { name: 'World Health Organization - AFRO', desc: 'Technical partnership on the WHO HEARTS initiative for cardiovascular disease management.', type: 'International' },
    { name: 'Resolve to Save Lives', desc: 'Partnership implementing standardised hypertension treatment protocols in African healthcare systems.', type: 'NGO' },
    { name: 'African Academy of Sciences', desc: 'Collaborating on capacity building and research funding for African cardiovascular scientists.', type: 'Continental' },
  ];

  return (
    <MemberOnlyOverlay previewTitle="Partners">
      <div data-testid="partners-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <SEO path="/partners" title="AFHOS Partners" description="Our partnerships with WHO, ISH, WHL, and other international organizations advancing cardiovascular health across Africa." />
        <div className="page-header">
          <p className="overline">{t('partners.overline')}</p>
          <h1 data-testid="partners-title">{t('partners.title')}</h1>
          <p>{t('partners.subtitle')}</p>
        </div>

        <div className="content-section">
          <p>{t('partners.intro')}</p>
        </div>

        <div style={{ marginTop: '2rem' }}>
          {partners.map((p, i) => (
            <div key={i} className="card" data-testid={`partner-${i}`} style={{
              marginBottom: '1rem', display: 'flex', justifyContent: 'space-between',
              alignItems: 'flex-start', gap: '1rem', padding: '1.25rem 1.5rem'
            }}>
              <div>
                <h4 style={{ marginBottom: '0.25rem' }}>{p.name}</h4>
                <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{p.desc}</p>
              </div>
              <span className="badge-type" style={{ flexShrink: 0 }}>{p.type}</span>
            </div>
          ))}
        </div>

        <div className="content-section" style={{ marginTop: '2rem' }}>
          <h2>{t('partners.partnershipTitle')}</h2>
          <p>
            {t('partners.partnershipDesc')} <a href="mailto:info@afhos.africa">info@afhos.africa</a>
          </p>
        </div>
      </div>
    </MemberOnlyOverlay>
  );
};

export default Partners;
